import React, { useEffect, useState } from 'react';
import { ShoppingCart } from 'lucide-react';
const socialProofData = [{
  name: 'María',
  city: 'La Plata',
  minutes: 3
}, {
  name: 'Carolina',
  city: 'Quilmes',
  minutes: 7
}, {
  name: 'Luciana',
  city: 'Mar del Plata',
  minutes: 12
}, {
  name: 'Gabriela',
  city: 'Lanús',
  minutes: 5
}, {
  name: 'Florencia',
  city: 'Avellaneda',
  minutes: 9
}, {
  name: 'Valeria',
  city: 'Morón',
  minutes: 2
}, {
  name: 'Andrea',
  city: 'San Isidro',
  minutes: 15
}, {
  name: 'Daniela',
  city: 'Lomas de Zamora',
  minutes: 6
}];
export function HeroSection() {
  const [notification, setNotification] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    const showNotification = () => {
      setNotification(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % socialProofData.length;
    };
    const initialTimeout = setTimeout(showNotification, 5000);
    const interval = setInterval(showNotification, 25000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const currentProof = notification !== null ? socialProofData[notification] : null;
  return <section className="relative overflow-hidden min-h-[calc(100vh-32px)] flex items-center justify-center py-6 px-4 bg-gradient-to-br from-[#E91E63] via-[#AB47BC] to-[#00BCD4]" data-id="element-32">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-33">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-white/5 rounded-full blur-[100px]" data-id="element-34"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-35">
        {/* Badge dorado */}
        <div className="inline-flex items-center gap-1.5 bg-[#F5F5F5] text-[#333333] font-bold text-[11px] px-4 py-1 rounded-full mb-3 shadow-lg shadow-black/10" data-id="element-36">
          <span data-id="element-37">⭐</span>
          <span data-id="element-38">Atención Docentes de Secundaria</span>
          <span data-id="element-39">⭐</span>
        </div>

        {/* Título dramático con serif */}
        <h1 className="mb-3 max-w-3xl drop-shadow-lg" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-40">
          <span className="block text-white text-[22px] md:text-[34px] font-extrabold leading-tight" data-id="element-41">
            Dominá la Intensificación:
          </span>
          <span className="block text-[#B3E5FC] text-[24px] md:text-[38px] font-black leading-tight mt-0.5" data-id="element-42">
            Pack Completo para Primer Año de Secundaria
          </span>
        </h1>

        {/* Mockup con badge 50% OFF */}
        <div className="relative w-full max-w-[160px] md:max-w-[220px] mx-auto mb-2" data-id="element-43">
          <div className="absolute -bottom-2 -right-4 md:-bottom-3 md:-right-5 z-20 w-[50px] h-[50px] md:w-[62px] md:h-[62px] rounded-full bg-[#CDDC39] shadow-xl shadow-black/25 flex flex-col items-center justify-center animate-[pulse_2s_ease-in-out_infinite] border-[2.5px] border-white/80" data-id="element-44">
            <span className="text-[#1A1A1A] font-extrabold text-[15px] md:text-[18px] leading-none" data-id="element-45">
              50%
            </span>
            <span className="text-[#1A1A1A] font-bold text-[9px] md:text-[10px] leading-none -mt-0.5" data-id="element-46">
              OFF
            </span>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/p6GYZiSNJvp5i9NCrAdokN/943f7890-4b64-4a37-bcbd-f47221ceb5fe.png" alt="Mockup del Mega Pack de Intensificación" className="w-full h-auto drop-shadow-[0_15px_30px_rgba(0,0,0,0.30)] animate-[float_3s_ease-in-out_infinite]" width="269" height="340" fetchPriority="high" decoding="sync" data-id="element-47" />
        </div>

        {/* Subtítulo */}
        <p className="text-[13px] md:text-[16px] text-white max-w-xl mb-4 leading-relaxed font-normal" data-id="element-48">
          Alineado al Régimen Académico de Secundaria y a los Diseños
          Curriculares vigentes de la Provincia de Buenos Aires.
        </p>

        {/* Botón CTA único */}
        <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9dBQQc9h2ha4bWIEiqNW5/es-ar" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#C0FF33] hover:bg-[#B0EF23] text-[#1A1A1A] font-bold text-[16px] md:text-[18px] h-[50px] md:h-[56px] px-10 md:px-14 rounded-xl shadow-xl shadow-lime-400/30 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lime-400/50 w-full sm:w-auto" data-id="element-49">
          ¡Quiero el MegaPack! →
        </a>
      </div>

      {/* Notificación de prueba social */}
      <div className={`fixed bottom-6 left-6 z-50 transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-50">
        {currentProof && <div className="bg-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3 max-w-xs border border-gray-100" data-id="element-51">
            <div className="bg-[#E91E63]/10 p-2 rounded-full flex-shrink-0" data-id="element-52">
              <ShoppingCart className="w-4 h-4 text-[#E91E63]" data-id="element-53" />
            </div>
            <div className="text-left" data-id="element-54">
              <p className="text-[12px] font-semibold text-[#1A1A1A] leading-tight" data-id="element-55">
                {currentProof.name} de {currentProof.city}
              </p>
              <p className="text-[11px] text-gray-500 mt-0.5" data-id="element-56">
                adquirió el MegaPack hace {currentProof.minutes} min
              </p>
            </div>
          </div>}
      </div>
    </section>;
}